// extracted by extract-css-chunks-webpack-plugin
module.exports = {"suggestionWrapper":"_2Hzk86"};